import { render, staticRenderFns } from "./DeclarationPrintSettingsModal.vue?vue&type=template&id=7b83d25a&scoped=true&"
import script from "./DeclarationPrintSettingsModal.vue?vue&type=script&lang=js&"
export * from "./DeclarationPrintSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationPrintSettingsModal.vue?vue&type=style&index=0&id=7b83d25a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b83d25a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCheckbox,VDialog,VIcon,VProgressCircular,VRadio,VRadioGroup,VTextField})
